import { ILocalOrderState } from "shared/atoms/localOrder.atom";

export default (currentLocalOrder: ILocalOrderState): number => {
  const listItemsIds = Object.keys(currentLocalOrder.items);

  return listItemsIds.reduce((total: number, entityId: string) => {
    return total + currentLocalOrder.items[entityId].quantity;
  }, 0);
};
